import { Icon, IconName } from "@/components/Icon";
import { GetConfig } from "@/types/Api/Common/Home/getConfig";
import { UserInfo } from "@/types/Api/User/User/MyAccount/login";
import { List } from "antd-mobile";
import styles from "./styles.module.scss";
export type Action = {
  type: string;
  icon: IconName;
  text: string;
  extra?: (data: {
    user: UserInfo;
    config: GetConfig["response"] | null;
  }) => string | number | React.ReactNode;
  extraArrow?: (data: {
    user: UserInfo;
    config: GetConfig["response"] | null;
  }) => boolean;
};
export type ActionListProps = {
  actions: Action[];
  user: UserInfo;
  config: GetConfig["response"] | null;
  onAction: (type: string, data: any) => void;
};
export const ActionList = ({
  actions,
  user,
  onAction,
  config
}: ActionListProps) => {
  return <List className={styles.list} data-sentry-element="List" data-sentry-component="ActionList" data-sentry-source-file="index.tsx">
      {actions.map((action: Action) => {
      const showExtra = typeof action.extraArrow === "function" ? action.extraArrow({
        user,
        config
      }) : true;
      return <List.Item className={styles.listItem} key={action.type} prefix={<div className={styles.listItemIcon}>
                <Icon name={action.icon} size={"20px"} />
              </div>}>
            <div className={styles.listItemContent} onClick={() => showExtra ? onAction(action.type, user) : undefined}>
              <div className={styles.listItemText}>{action.text}</div>
              <div className={styles.listItemExtra}>
                <div className={styles.listItemExtraText}>
                  {typeof action.extra === "function" ? action.extra({
                user,
                config
              }) : ""}
                </div>
                {showExtra ? <div className={styles.listItemExtraIcon}>
                    <Icon name={"user-arrow-right"} size={"16px"} />
                  </div> : null}
              </div>
            </div>
          </List.Item>;
    })}
    </List>;
};